import { FormEvent, useContext } from 'react';

import Grid from '@mui/material/Unstable_Grid2';

import { Form, Formik } from 'formik';

import {
  DatePickerGroup,
  LinkButton,
  SearchableMultiSelect,
  Select,
  SubmitButton,
  ButtonsBlock,
  SelectWithSearch,
} from 'components/UIComponents';

import { BulkSelectContext } from 'context/BulkSelectContext';
import { FilterContext } from 'context/FilterContext';

import {
  getOutletOptions,
  getProductOptions,
  getResponseFileNameOptions,
  getResponseCodeOptions,
} from 'helpers/collections';
import { nonEmptyValues } from 'helpers/utils';

import { statusOptions } from 'constants/responses';

import { IResponseFilterOptions } from 'interfaces/Response/IResponseFilterOptions';
import UploadResponsesForm from 'components/forms/responses/UploadResponsesForm';

import { controllWrapperStyles } from './styledComponents';

const emptyValues = {
  dateFrom: '',
  dateTo: '',
  isException: '',
  productId: [],
  outletId: [],
  fileId: [],
  code: '',
};

const ActionsBar = () => {
  const { filterOptions, onFilter } = useContext(FilterContext);
  const { onChangeSelectAll } = useContext(BulkSelectContext);

  const initial = filterOptions as IResponseFilterOptions;

  const initialValues = {
    dateFrom: initial.dateFrom || '',
    dateTo: initial.dateTo || '',
    isException: initial.isException || '',
    productId: initial.productId || [],
    outletId: initial.outletId || [],
    fileId: initial.fileId || [],
    code: initial.code || '',
  };

  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize={true}
      onSubmit={(values) => {
        onChangeSelectAll(false);
        const present = nonEmptyValues(values);
        onFilter(present);
      }}
    >
      {({ values, handleSubmit, resetForm }) => {
        return (
          <Form>
            <Grid container columnSpacing={{ xs: 2, lg: 3 }} rowSpacing={2}>
              <Grid xs={3}>
                <DatePickerGroup
                  startProps={{
                    name: 'dateFrom',
                    direction: 'column',
                    maxDate: values.dateTo,
                    placeholder: 'Any Date',
                  }}
                  endProps={{
                    name: 'dateTo',
                    direction: 'column',
                    minDate: values.dateFrom,
                    placeholder: 'Any Date',
                  }}
                  label="Response Date"
                  connector="to"
                  styles={controllWrapperStyles}
                  direction="column"
                />
              </Grid>
              <Grid xs={3}>
                <SearchableMultiSelect
                  name="productId"
                  label="Product"
                  initial={initialValues.productId}
                  getOptionsList={getProductOptions}
                  styles={controllWrapperStyles}
                  direction="column"
                />
              </Grid>
              <Grid xs={3}>
                <SearchableMultiSelect
                  name="outletId"
                  label="Outlet"
                  initial={initialValues.outletId}
                  getOptionsList={getOutletOptions}
                  styles={controllWrapperStyles}
                  direction="column"
                />
              </Grid>
              <Grid xs={3}>
                <Select
                  name="isException"
                  placeholder="Any Status"
                  label="Status"
                  options={statusOptions}
                  styles={controllWrapperStyles}
                  direction="column"
                  emptyOptionLabel="Any Status"
                />
              </Grid>
            </Grid>
            <Grid container columnSpacing={{ xs: 2, lg: 3 }} rowSpacing={2}>
              <Grid xs={3}>
                <SelectWithSearch
                  name="code"
                  label="Code"
                  placeholder="Any Code"
                  initial={{
                    key: initialValues.code || '',
                    value: initialValues.code || '',
                  }}
                  getOptionsList={getResponseCodeOptions}
                  styles={controllWrapperStyles}
                  direction="column"
                  emptyOptionLabel="Any Code"
                />
              </Grid>
              <Grid xs={3}>
                <SearchableMultiSelect
                  name="fileId"
                  label="File"
                  initial={initialValues.fileId}
                  getOptionsList={getResponseFileNameOptions}
                  styles={controllWrapperStyles}
                  direction="column"
                />
              </Grid>
              <Grid display="flex" rowSpacing={2} justifyContent="flex-end" alignItems="flex-end" xs={6}>
                <ButtonsBlock>
                  <LinkButton
                    onClick={() => {
                      resetForm({ values: emptyValues });
                      onChangeSelectAll(false);
                      onFilter({});
                    }}
                  >
                    Clear filter
                  </LinkButton>
                  <SubmitButton onClick={(values: FormEvent<HTMLFormElement>) => handleSubmit(values)}>
                    Apply Filter
                  </SubmitButton>
                  <UploadResponsesForm />
                </ButtonsBlock>
              </Grid>
            </Grid>
          </Form>
        );
      }}
    </Formik>
  );
};

export default ActionsBar;
